// WHAT: Hook for accessing Sidebar context
// WHY:  Provides type-safe access to sidebar state and controls
// DOMAIN: core → layout
// DEPENDENCIES: SidebarContext from SidebarContext.tsx
// RISKS:
//   - NOTE: Throws error if used outside SidebarProvider

import { useContext } from "react";

import { SidebarContext } from "./SidebarContext.shared";

/**
 * WHAT:
 *   Hook for accessing sidebar state and control functions.
 *
 * WHY:
 *   Provides type-safe access to sidebar context without prop drilling.
 *
 * BEHAVIOR:
 *   - Returns sidebar state (isOpen) and control functions (toggle, open, close)
 *   - Throws error if used outside SidebarProvider
 *
 * RISKS:
 *   - NOTE: Must be used within SidebarProvider - throws error otherwise
 *
 * @returns Sidebar context with state and control functions
 *
 */
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
  return context;
};
